(() => {
  'use strict';
  const initialise = scope => {
    window.KeepsakeMarket?.projectCart(scope);
    scope.querySelectorAll('[data-keepsake-cart]').forEach(form => {
      if (form.dataset.cartInitialised === 'true') return;
      form.dataset.cartInitialised = 'true';
      const checkout = form.querySelector('[data-cart-checkout]');
      const status = form.querySelector('[data-cart-status]');
      const deliveryLabel = form.querySelector('[data-delivery-label]');
      const deliveryAmount = form.querySelector('[data-delivery-amount]');
      const originalDelivery = {label: deliveryLabel?.textContent, amount: deliveryAmount?.textContent};
      const marketBlocked = () => window.KeepsakeMarket?.isCheckoutReady?.() === false;
      const blocked = () => form.dataset.checkoutBlocked === 'true' || marketBlocked();
      const message = value => { if (status) status.textContent = value || ''; };
      let submitting = false;
      let checkingOffer = false;
      const updateState = () => {
        if (checkout) checkout.disabled = blocked();
        const unavailable = marketBlocked();
        message(unavailable ? form.dataset.marketUnavailableMessage : '');
        if (deliveryLabel) deliveryLabel.textContent = unavailable ? form.dataset.deliveryLabel : originalDelivery.label;
        if (deliveryAmount) deliveryAmount.textContent = unavailable ? form.dataset.marketPendingLabel : originalDelivery.amount;
      };
      form.addEventListener('submit', async event => {
        const isCheckout = event.submitter?.name === 'checkout';
        if (isCheckout && !blocked() && window.KeepsakeOffer?.blocksCheckout()) {
          event.preventDefault();
          if (checkingOffer || submitting) return;
          checkingOffer = true; form.setAttribute('aria-busy', 'true');
          try { if (await window.KeepsakeOffer.prepareCheckout()) form.requestSubmit(checkout); }
          finally { checkingOffer = false; if (!submitting) form.removeAttribute('aria-busy'); }
          return;
        }
        if (submitting || !isCheckout || blocked()) { event.preventDefault(); if (!submitting) message(marketBlocked() ? form.dataset.marketUnavailableMessage : form.dataset.blockedMessage); return; }
        submitting = true;
        form.setAttribute('aria-busy', 'true');
        message(form.dataset.checkoutMessage);
      });
      window.addEventListener('pageshow', () => { submitting = false; form.removeAttribute('aria-busy'); updateState(); });
      window.addEventListener('keepsake:market-context', updateState);
      updateState();
      if (typeof location !== 'undefined' && new URLSearchParams(location.search).get('kc_checkout') === '1') {
        const clean = new URL(location.href); clean.searchParams.delete('kc_checkout');
        window.history.replaceState(window.history.state, '', clean.pathname + clean.search + clean.hash);
        if (!blocked() && checkout && !checkout.disabled) {
          if (window.KeepsakeOffer?.ready) Promise.resolve(window.KeepsakeOffer.ready).then(() => form.requestSubmit(checkout));
          else form.requestSubmit(checkout);
        }
        else message(marketBlocked() ? form.dataset.marketUnavailableMessage : form.dataset.blockedMessage);
      }
    });
  };
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  if (window.KeepsakeBag) return;
  const configNode = document.getElementById?.('keepsake-bag-config');
  if (!configNode) return;
  let config; try { config = JSON.parse(configNode.textContent); } catch { return; }
  const root = window.Shopify?.routes?.root || '/';
  if (!/^\/(?:[A-Za-z0-9_-]+\/)*$/.test(root)) return;
  const link = document.createElement('a'); link.className = 'keepsake-floating-bag';
  link.href = config.cartUrl || root + 'cart'; link.dataset.keepsakeFloatingBag = '';
  link.setAttribute('aria-label', config.unknown || config.label);
  link.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M5 7h14l1 14H4L5 7Z M8 8V6a4 4 0 0 1 8 0v2" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg><span data-bag-label></span><span class="floating-bag-count" data-bag-count>—</span>';
  link.querySelector('[data-bag-label]').textContent = config.label;
  document.body.append(link);
  let pending = null;
  const refresh = () => {
    if (pending) return pending;
    pending = (async () => {
      try {
        const response = await fetch(root + 'cart.js', {credentials:'same-origin',cache:'no-store',headers:{accept:'application/json'},signal:AbortSignal.timeout(8000)});
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        const count = Number.isSafeInteger(cart.item_count) ? cart.item_count : Array.isArray(cart.items) ? cart.items.reduce((total,item) => total + (Number.isSafeInteger(item.quantity) ? item.quantity : 0), 0) : null;
        if (count === null || count < 0) throw new Error('Cart unavailable');
        link.querySelector('[data-bag-count]').textContent = String(count);
        link.setAttribute('aria-label', String(config.count || config.label).replaceAll('__COUNT__', String(count)).replaceAll('{{ count }}', String(count)));
        return cart;
      } catch { link.querySelector('[data-bag-count]').textContent = '—'; link.setAttribute('aria-label', config.unknown || config.label); return null; }
      finally { pending = null; }
    })();
    return pending;
  };
  const added = async image => {
    const updateConfirmedCount = async () => { if (pending) await pending; await refresh(); };
    updateConfirmedCount().catch(() => {});
    if (!image?.getBoundingClientRect || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    const from = image.getBoundingClientRect(), to = link.getBoundingClientRect();
    if (!from.width || !to.width) return;
    const ghost = document.createElement('img'); ghost.src = image.src; ghost.alt = ''; ghost.className = 'bag-flying-photo';
    ghost.style.cssText = `left:${from.left}px;top:${from.top}px;width:${from.width}px;height:${from.height}px`;
    document.body.append(ghost);
    if (typeof ghost.animate !== 'function') { ghost.remove(); return; }
    const motion = ghost.animate([{transform:'translate(0,0) scale(1)',opacity:1},{transform:`translate(${to.left + to.width/2 - from.left - from.width/2}px,${to.top + to.height/2 - from.top - from.height/2}px) scale(.08)`,opacity:.15}], {duration:520,easing:'cubic-bezier(.22,.61,.36,1)',fill:'forwards'});
    let animationDeadline;
    try { await Promise.race([motion.finished, new Promise(resolve => { animationDeadline = setTimeout(resolve, 600); })]); }
    catch {} finally { clearTimeout(animationDeadline); motion.cancel?.(); ghost.remove(); }
  };
  window.KeepsakeBag = Object.freeze({refresh,added});
  window.addEventListener('pageshow',refresh); window.addEventListener('focus',refresh);
  refresh();
})();
